// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1pciq","label":"styles_label__BiuFu"};